/**
 * The model representing the result
 * @class
 */
Selector.Model.Result = Backbone.Model.extend(
/** @lends Selector.Model.Result# */
{
    defaults: {
        "results": [],
        "NoRelevantResultsBasedOnAnswers": false,
        "jurisdictionId": null
    },
    escapeRegExp: function(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escapes special characters for regex
    },
    fetchProduct: function() {
    var _this = this;
    if (this.get("results") !== null) {
        if (ele.selector.data.CONFIG.SELECTORTYPE === 'HumanResourcesCheckuphealthcheck'
            || ele.selector.data.CONFIG.SELECTORTYPE === 'ResidentialLandlordCheckuphealthcheck'
            || ele.selector.data.CONFIG.SELECTORTYPE === 'GeneralBusinessCheckuphealthcheck') {

            const jurisdictionId = this.get('jurisdictionId');  // Use the jurisdictionId stored in the model
            if (jurisdictionId != 0) {
                // Initialize an empty array to store product names
                const productnames = [];
                var $jurisdictionSelector = $('.form-select');

                // Loop through the results array
                ele.selector.data.RESULTS.forEach(result => {
                    // Check if the result object has 'PRODUCTNAME' property
                    if (result.PRODUCTNAME) {
                        try {
                            // Try to parse PRODUCTNAME as JSON array
                            const productNameArray = JSON.parse(result.PRODUCTNAME);

                            // Check if it's an array and push all names
                            if (Array.isArray(productNameArray)) {
                                productnames.push(...productNameArray);
                            } else {
                                // If it's not an array, just push it as a single string
                                productnames.push(result.PRODUCTNAME);
                            }
                        } catch (e) {
                            // If parsing fails, assume it's a single string and push it
                            productnames.push(result.PRODUCTNAME);
                        }
                    }
                });

                // Convert the productnames array into a URL-encoded query parameter
                const productnamesParam = productnames.map(name => encodeURIComponent(name)).join('&productnames=');

                // Construct the full URL with query parameters
                const url = `${ele.uri.buildUrl('selectorresultproducts')}&jurisdictionid=${jurisdictionId}&productnames=${productnamesParam}`;

                // Send GET request using fetch
                fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    // Check if the response is OK, then extract the JSON body
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();  // Parse the response as JSON
                })
                .then(data => {
                    // Now you can access the data from the server response
                    // Iterate over the results and the API response
                    const results = _this.get("results");
                    let modeljurisdictionId = _this.get('jurisdictionId');
                    results.forEach(result => {
                        if(result?.PRODUCTNAME){
                            let productNamesArray = [];
                            try {
                                // Parse PRODUCTNAME as a JSON array
                                productNamesArray = JSON.parse(result.PRODUCTNAME);
                                if (!Array.isArray(productNamesArray)) {
                                    productNamesArray = [productNamesArray];
                                }
                            } catch (e) {
                                // If parsing fails, handle it as a single string
                                productNamesArray = [result.PRODUCTNAME];
                            }

                            if(data?.DATA && Array.isArray(data.DATA)){
                                // Iterate over the API response data
                                data.DATA.forEach(apiProduct => {
                                    const apiProductName = apiProduct.PRODUCTNAME;

                                    // Check if any of the product names in the array match the API product name
                                    productNamesArray.some(resultProductName => {                                      
                                                                                                             
                                        // Clear any old suggestions if the jurisdictions no longer align
                                        if (result?.suggestionJurisdictionID && result.suggestionJurisdictionID !== modeljurisdictionId) {
                                            delete result.PRODUCTID;
                                            delete result.OBJECTID;
                                            delete result.suggestionJurisdictionID;
                                            delete result.TEMPORARYTITLE;
                                        }

                                        // Create a regular expression to match product names
                                        const productNamePattern = new RegExp(
                                            _this.escapeRegExp(apiProductName.replace(/\s*\([A-Z]{2}\)\s*$/, "").trim()), 'i'
                                        );   
                                        
                                        // Test if the API product name matches any of the result product names
                                        if (productNamePattern.test(resultProductName)) {
                                            // If a match is found, add the OBJECTID and PRODUCTID
                                            result.OBJECTID = apiProduct.OBJECTID;
                                            result.PRODUCTID = apiProduct.PRODUCTID;
                                            result.ENABLED = results.ProductEnabled;                                            
                                            result.TEMPORARYTITLE = apiProductName;
                                            result.suggestionJurisdictionID = modeljurisdictionId;
                                            
                                            return true;  // Exit the 'some' loop early if a match is found
                                        }

                                        return false;  // Continue if no match is found
                                    });
                                });
                            }
                        }
                    });

                    if ($jurisdictionSelector.val() != '-' && $jurisdictionSelector.val() !== null) {
                        jQuery.post('..' + ele.config.directory + '/index.cfm?event=storeJurisdictionInSession', {jurisdictionID: $('.form-select').val()});
                    }
                    $('.e_selector_tabs').hide();
                    
                    const newResults = [...results];
                    _this.set({results: newResults}); 
                    this.trigger('change:results');
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            } else {
                // Clear any old suggestions 
                ele.selector.data.RESULTS.forEach(result => {
                    delete result.PRODUCTID;
                    delete result.OBJECTID;
                    delete result.suggestionJurisdictionID;
                })
            }
        } else {
            //only do this for first result
            if (this.get("results") !== null && this.get("results").length === 1) {

                var result = this.get("results")[0];

                if (result.PRODUCTID != 0 && typeof result.PRODUCTID != "undefined") {
                    return fetch(ele.uri.buildUrl("productdata", {productId: result.PRODUCTID, ajax: 1}))
                        .then(function(response) {
                            return response.json(); 
                        })
                        .then(function(product) {
                            $.extend(result, product);
                            var results = _this.get("results");
                            results[0] = result;
                            _this.set({results: results});
                            return product;
                        })
                        .catch(function(error){
                            console.error(error);
                        });
                }
            }
        }
    }
    return null;
}

	
});